<div [style.fontSize]="size" class="hestia-logo-project">
    <i class="icon-eh-24-logo">
        <span class="path1"></span>
        <span class="path2"></span>
        <span class="path3"></span>
        <span class="path4"></span>
        <span class="path5"></span>
    </i>
</div>
